import api from '@/services/api';

export default {
  namespaced: true,

  state: () => ({
    entries: [],
    activeEntry: null,
  }),

  getters: {
    isTracking: (state) => !!state.activeEntry,
    activeEntry: (state) => state.activeEntry,
    allEntries: (state) => [...state.entries].sort((a, b) => new Date(b.startTime) - new Date(a.startTime)),

    todayEntries(state) {
      const today = new Date().toDateString();
      return state.entries.filter((e) => new Date(e.startTime).toDateString() === today);
    },

    weekEntries(state) {
      const now = new Date();
      const monday = new Date(now);
      monday.setDate(now.getDate() - ((now.getDay() + 6) % 7));
      monday.setHours(0, 0, 0, 0);
      return state.entries.filter((e) => new Date(e.startTime) >= monday);
    },

    totalMinutesToday(state, getters) {
      return getters.todayEntries.reduce((sum, e) => sum + (e.durationMinutes || 0), 0);
    },

    totalMinutesWeek(state, getters) {
      return getters.weekEntries.reduce((sum, e) => sum + (e.durationMinutes || 0), 0);
    },
  },

  mutations: {
    SET_ENTRIES(state, entries) {
      state.entries = entries;
    },
    SET_ACTIVE(state, entry) {
      state.activeEntry = entry;
    },
    ADD_ENTRY(state, entry) {
      state.entries.push(entry);
    },
    UPDATE_ENTRY(state, updated) {
      const idx = state.entries.findIndex((e) => e.id === updated.id);
      if (idx !== -1) state.entries.splice(idx, 1, updated);
    },
    DELETE_ENTRY(state, id) {
      state.entries = state.entries.filter((e) => e.id !== id);
    },
    RESET(state) {
      state.entries = [];
      state.activeEntry = null;
    },
  },

  actions: {
    async init({ commit }) {
      const [entriesRes, activeRes] = await Promise.all([
        api.get('/entries'),
        api.get('/entries/active'),
      ]);
      commit('SET_ENTRIES', entriesRes.data);
      commit('SET_ACTIVE', activeRes.data);
    },

    reset({ commit }) {
      commit('RESET');
    },

    async startTracking({ commit }, { project, description }) {
      const { data } = await api.post('/entries/start', { project, description });
      commit('SET_ACTIVE', data);
    },

    async stopTracking({ commit }) {
      const { data } = await api.post('/entries/stop');
      commit('SET_ACTIVE', null);
      commit('ADD_ENTRY', data);
    },

    async discardActive({ commit }) {
      await api.delete('/entries/active');
      commit('SET_ACTIVE', null);
    },

    async deleteEntry({ commit }, id) {
      await api.delete(`/entries/${id}`);
      commit('DELETE_ENTRY', id);
    },

    async updateEntry({ commit }, entry) {
      const { data } = await api.put(`/entries/${entry.id}`, entry);
      commit('UPDATE_ENTRY', data);
    },
  },
};
